import { jwtDecode } from "jwt-decode";
import { removeLocalItem, removeSessionItem, setLocalItem } from "./storageUtils";
import { CC_PRODUCT_ID, GIVENNAME, IS_POD, NAME_ID, OXE_CLIENT_INFO, OXE_UMC_CONNECTED, PROJECT_ID, ROLE, SESSION_INDEX, SURNAME, TBL_PAGE_SIZE, TOKEN_1, TOKEN_2 } from "./Constants";

export const decodeToken = (token) => {
    try {
        const decoded = jwtDecode(token);
        return decoded;
    } catch (error) {
        console.error('Invalid token:', error);
        return null;
    }
}

export const setRefreshTimeout = (exp, refreshTokenFunction) => {
    const expirationTime = exp*1000 - (new Date().getTime()) - 60000; // Set to refresh 1 minute before expiration

    const timer = setTimeout(() => {
        refreshTokenFunction()
    }, expirationTime);

    return timer
}

export const clearTimeouts = (timerArr) => {
    timerArr.map(timer => clearTimeouts(timer))
}

export const isTokenExpired = (token) => {
    const decoded = decodeToken(token)
    if (decoded?.exp && (decoded.exp*1000 > new Date().getTime())) {

        return false
    }
    else return true
}

export const clearSession = () => {
    removeSessionItem(CC_PRODUCT_ID)
    removeSessionItem(TOKEN_1)
    removeSessionItem(TOKEN_2)
    removeSessionItem(OXE_UMC_CONNECTED)
    removeSessionItem(OXE_CLIENT_INFO)
    removeSessionItem(ROLE)
    removeSessionItem(IS_POD)
    removeSessionItem(PROJECT_ID)
    removeSessionItem(TBL_PAGE_SIZE)
}

export const setLocalStorageItems = (data) => {
    setLocalItem(SESSION_INDEX, data?.sessionIndex)
    setLocalItem(NAME_ID, data?.nameId)
    setLocalItem(GIVENNAME, data?.givenName)
    setLocalItem(SURNAME, data?.surName)
}

export const clearLocalStorage = () => {
    removeLocalItem(SESSION_INDEX)
    removeLocalItem(NAME_ID)
    removeLocalItem(GIVENNAME)
    removeLocalItem(SURNAME)
}